export default "/images/11c2487b8a89f4e4b4798f12d8a2d16d.png";